
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "inline"
    }}>{`Inline`}</h1>
    <p>{`An inline component is a `}<inlineCode parentName="p">{`<span>`}</inlineCode>{` with `}<inlineCode parentName="p">{`display: inline`}</inlineCode>{`, and a starting point for building your own custom inline components.`}</p>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<>
  <Inline extend={{ background: 'yellow' }}>Hello</Inline> World
</>
`}</code></pre>
    <h3 {...{
      "id": "props---inline"
    }}>{`Props - Inline`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any valid React element, function, or a string specifying a name for an HTML element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`union(string,element,elementType,func)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'span'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A JSX node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`node`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Add an additional custom className to element. Warning: make sure it doesn't collide with the classNames being generated for the atomic CSS *`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`extend`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object containing valid CSS style declarations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`union(object,func,array)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;